@if (showMessage) {
    <div class="thressholdlimit-message-wrapper clear-both">
        <div class="content-message-container cashier-notifications mb-3">
            <div class="content-message info theme-info-i d-flex align-items-baseline">
                <div class="d-flex flex-column">
                    @if (
                        isBucketChanged &&
                        (isDailyThresholdLimit || isWeeklyThresholdLimit || isMonthlyThresholdLimit) &&
                        !(isDailyRgLimitMet || isWeeklyRgLimitMet || isMonthlyRgLimitMet)
                    ) {
                        <div
                            class="notification-text"
                            [vnDynamicHtml]="
                                'PARTY.CASHIER.web.deposit.threshold.limit.reaching.msg'
                                    | translate: { frequency: translateFrequency(), increaseLimitUrl: dataService?._depositInfo?.increaseLimitUrl }
                            "></div>
                    }
                    @if (
                        isBucketChanged &&
                        (isDailyRgLimitMet || isWeeklyRgLimitMet || isMonthlyRgLimitMet) &&
                        (isDailyThresholdLimit || isWeeklyThresholdLimit || isMonthlyThresholdLimit)
                    ) {
                        <div
                            class="notification-text"
                            [vnDynamicHtml]="
                                'PARTY.CASHIER.web.deposit.threshold.limit.reached.msg'
                                    | translate: { frequency: translateFrequency(), increaseLimitUrl: dataService?._depositInfo?.increaseLimitUrl }
                            "></div>
                    }
                </div>
            </div>
        </div>
    </div>
}
